module.exports = __webpack_public_path__ + "media/images/icon__paginationArrows@3x-622564a41cf921ca9d130c60e0bae9b6.png";